<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('dailyExpenseReport.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('dailyExpenseReport.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <ts-card>
            <ts-card-wrapper>
              <ts-loading-banner :loading="loading">
                <form>
                  <fieldset>
                    <legend>{{ $t('dailyExpenseReport.criteria') }}</legend>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="required">{{
                            $t('dailyExpenseReport.dateRange')
                          }}</label>
                          <a-range-picker
                            format="DD-MM-YYYY"
                            valueFormat="DD-MM-YYYY"
                            :defaultValue="rangeDate"
                            :defaultPickerValue="rangeDate"
                            @change="dateRangeChange"
                            :ranges="{
                              Today: [moment(), moment()],
                              'This Month': [
                                moment().startOf('month'),
                                moment().endOf('month')
                              ]
                            }"
                          >
                            <template slot="renderExtraFooter"></template>
                          </a-range-picker>
                          <div class="validate" v-if="errors.has('date_range')">
                            {{ errors.first('date_range') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{ $t('dailyExpenseReport.branch') }}</label>
                          <a-select
                            v-model="model.branch_id"
                            :options="branches"
                            class="ts-w-full"
                            showSearch
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            placeholder="All"
                            mode="multiple"
                          ></a-select>
                          <div class="validate" v-if="errors.has('branch_id')">
                            {{ errors.first('branch_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('dailyExpenseReport.expenseBy')
                          }}</label>
                          <ts-loading-banner :loading="employeeLoading">
                            <a-select
                              v-model="model.employee_id"
                              :options="employees"
                              class="ts-w-full"
                              showSearch
                              :filterOption="
                                (input, option) =>
                                  option.componentOptions.children[0].text
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                              "
                              placeholder="All"
                              mode="multiple"
                            ></a-select>
                          </ts-loading-banner>
                          <div
                            class="validate"
                            v-if="errors.has('employee_id')"
                          >
                            {{ errors.first('employee_id') }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('dailyExpenseReport.categoryExpense')
                          }}</label>
                          <ts-loading-banner :loading="categoryLoading">
                            <a-select
                              v-model="model.exp_cat_id"
                              :options="expcategories"
                              class="ts-w-full"
                              showSearch
                              :filterOption="
                                (input, option) =>
                                  option.componentOptions.children[0].text
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                              "
                              placeholder="All"
                              mode="multiple"
                            ></a-select>
                          </ts-loading-banner>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('dailyExpenseReport.ExpenseItem')
                          }}</label>
                          <ts-loading-banner :loading="expItemLoading">
                            <a-select
                              v-model="model.exp_id"
                              :options="expenseItemList"
                              class="ts-w-full"
                              showSearch
                              :filterOption="
                                (input, option) =>
                                  option.componentOptions.children[0].text
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                              "
                              placeholder="All"
                              mode="multiple"
                            ></a-select>
                          </ts-loading-banner>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('dailyCashAdvanceReport.currency')
                          }}</label>
                          <a-select
                            v-model="model.currency_id"
                            class="ts-w-full"
                            :options="currenciesFilter"
                            showSearch
                            placeholder="All"
                            mode="multiple"
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                          ></a-select>
                          <div
                            class="validate"
                            v-if="errors.has('currency_id')"
                          >
                            {{ errors.first('currency_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <ts-checkbox
                          v-model="model.with_product_serial"
                          class="ts-mb-4"
                        >
                          {{ $t('dailyExpenseReport.withProductSerial') }}
                        </ts-checkbox>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 ts-text-right">
                        <ts-button
                          color="success"
                          class="btn-block"
                          @click.prevent="exportExcel"
                          :waiting="exporting"
                          ><i class="far fa-file-excel"></i>
                          {{ $t('export') }}</ts-button
                        >
                      </div>
                      <div class="col-md-6 ts-text-right">
                        <ts-button
                          color="primary"
                          class="btn-block"
                          @click.prevent="preview"
                          :waiting="waiting"
                          ><i class="far fa-file-pdf"></i>
                          {{ $t('preview') }}</ts-button
                        >
                      </div>
                    </div>
                  </fieldset>
                </form>
              </ts-loading-banner>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('dailyExpenseReport.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'dailyCashAdvance',
  data() {
    return {
      waiting: false,
      exporting: false,
      loading: false,
      employeeLoading: false,
      categoryLoading: false,
      expItemLoading: false,
      errors: new Errors(),
      branches: [],
      employees: [],
      expcategories: [],
      expenseItems: [],
      // currencies: [],
      src: '',
      rangeDate: [moment(), moment()],
      model: {
        date_range: [
          moment().format('DD-MM-YYYY'),
          moment().format('DD-MM-YYYY')
        ],
        employee_id: undefined,
        branch_id: undefined,
        currency_id: undefined,
        exp_cat_id: [],
        with_product_serial: false,
        exp_id: []
      }
    }
  },
  created() {
    this.fetchLocation()
  },
  computed: {
    ...mapState('report/resource', ['currencies']),
    currenciesFilter() {
      if (!this.currencies) return []
      return this.currencies.map(el => ({
        value: el.currency_id,
        label: el.currency_description
      }))
    },
    expenseItemList() {
      if (this.model.exp_cat_id.length > 0) {
        return this.expenseItems
          .filter(g => _.includes(this.model.exp_cat_id, g.exp_cat_id))
          .map(el => ({
            value: el.exp_id,
            label: el.exp_item
          }))
      }
      return this.expenseItems.map(el => ({
        value: el.exp_id,
        label: el.exp_item
      }))
    }
  },
  methods: {
    ...mapActions('report/resource', [
      'getBranch',
      'getEmployee',
      'getCurrency'
    ]),
    ...mapActions('report/expense', ['getexpenseCategory', 'getExpitem']),
    moment,
    async fetchLocation() {
      this.loading = true
      await this.getCurrency()
      await this.getBranch()
        .then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.getEmployee()
        .then(response => {
          this.employees = response.data.map(el => ({
            value: el.employee_id,
            label: el.employee_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
      await this.getExpitem().then(response => {
        this.expenseItems = response.data
      })
      await this.getexpenseCategory().then(response => {
        this.expcategories = response.data.map(el => ({
          value: el.exp_cat_id,
          label: el.exp_category
        }))
      })
    },
    preview() {
      this.errors = new Errors()
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('report/expense/dailyExpensePdf', this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch('report/expense/dailyExpenseExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    dateRangeChange(rangeDate) {
      this.model.date_range = rangeDate
    }
  }
}
</script>
